export const SCALENE_BLOCK_FORM = "7040917";

export const SCALENE_BLOCK_FIELDS = Object.freeze({
  SIDES_INJECTED: "198531114",
  LOCATIONS: "192143750",
  FURTHER_INJECTION_DETAILS: "198531115",
  FIRST_INJECTATE: "192143753",
  FIRST_INJECTATE_QUANTITY: "192790365",
  SECOND_INJECTATE: "193643991",
  SECOND_INJECTATE_QUANTITY: "193643992",
  OUTCOME: "192257700",
  POST_PROCEDURE_COMMENTS: "193165018",
} as const);

export type ScaleneBlockFields = keyof typeof SCALENE_BLOCK_FIELDS;

export const SCALENE_BLOCK_FIELDS_SET = new Set(
  (Object.keys(SCALENE_BLOCK_FIELDS) as ScaleneBlockFields[]).map(
    (key: ScaleneBlockFields) => SCALENE_BLOCK_FIELDS[key]
  )
);

export const SCALENE_BLOCK_REQUIRED_FIELDS = [
  SCALENE_BLOCK_FIELDS.SIDES_INJECTED,
  SCALENE_BLOCK_FIELDS.FIRST_INJECTATE,
  SCALENE_BLOCK_FIELDS.FIRST_INJECTATE_QUANTITY,
];
